import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import ReactGA from "react-ga4";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

import App from "src/App";
import reportWebVitals from "src/reportWebVitals";
import theme from "src/common/theme";
import config from "src/common/config";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

(async () => {
  if (config.gaMeasurementId) {
    ReactGA.initialize(config.gaMeasurementId);
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  const LDProvider = await asyncWithLDProvider({
    clientSideID: config.launchDarklyKey,
    options: {
      streaming: false,
    },
  });

  root.render(
    <React.StrictMode>
      <LDProvider>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </LDProvider>
    </React.StrictMode>,
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
